import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/_layout/tickets/_layout/')({
  component: () => null, // La coda la renderizza il layout parent.
});
